import { validateIsUserInvited } from "../clients/extraRequest";

export const validateIfIsInvitedUser = async () => {
  const isUserInvited = await validateIsUserInvited()
  return isUserInvited.isLoginNeeded
}

